module.exports = __webpack_public_path__ + "img/moneyback.7c06af9d.png";